module.exports = __webpack_public_path__ + "static/media/blackberry.9d8239fc.jpg";